export default __webpack_public_path__ + "static/media/1.ac03cb99.jpg";